export default {
    FiliadoValoresDeContricao: axios.create({
        baseURL: process.env.VUE_APP_ENDPOINT_API + "filiados-valores-de-contribuicao"
    })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/FiliadosValoresDeContribuicao.js
// module id = N/dU
// module chunks = 32